import { render, staticRenderFns } from "./PlayStoreButton.vue?vue&type=template&id=e5a8bf8e&"
import script from "./PlayStoreButton.vue?vue&type=script&lang=js&"
export * from "./PlayStoreButton.vue?vue&type=script&lang=js&"
import style0 from "./PlayStoreButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PlayStoreButton.vue"
export default component.exports